<template>
<div>
    <div class="form-group">
    <label  for="categoria"><strong>Categoria</strong></label>
        <select @change="$emit('update',categoryId)" :disabled="!isActive" :required="required" id="category" name="category" class="form-control" v-model="categoryId">
        <optgroup v-for="(group, name,index) in items" :key="index" :label="name">
         <option v-if="optionBase" value="0"> -- Seleziona una categoria -- </option>    
        <option v-for="(option,index) in group" :key="index" :value="option.value">
            {{ option.text  }}
        </option>
        </optgroup>
        </select> 
    </div>
</div>

</template>
<script>
import {mapGetters }         from 'vuex';

import api                   from "@/api";
import {setCategory,sortCat} from '@/functions';   

export default {
  props : ['isActive','optionBase','required','Id'] , 
  components: {},
  data() {
    return {

      categoryId             : this.Id ? this.Id : 0 ,
      items                  : [],
      spinner                : false
           
    };
  },
  computed:
  {
      ...mapGetters(['company']) 
  },
  mounted: function() {
  
  },
  created: function() {
      this.getData()
  },
  methods: 
  {

    
    async getData()
    {
            
      let sp    = {'sp'       : 'spCategorySelect'}
      let data  = {'companyId': this.company.Id}
      let json   = Object.assign(data, sp);


      await api.post(json).then(res => {
          
      

          if(res.status==200)
            {
              this.items   = setCategory(res.data.recordsets[0])    
              
            }
           else if(res.status==500)
           {
                console.log(res.data)

                
                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
      
      

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });

    

    },
  
    
    
  
}

}
</script>
<style scoped>

</style>